'use client';
import {
  ComparisonSection,
  EventsSection,
  FeatureSection,
  HeroSection,
  IndustriesSection,
  MetricsSection,
  ProblemSection,
  SecondaryCTA,
  PrimaryCTA,
  Testimonials,
} from '@/app/components';
import { data } from './data';
import { adventurepark } from "./images";

const Content = () => {
  return (
    <>
      <HeroSection {...data.heroData} image={adventurepark} />
      <ProblemSection {...data.problemData} />
      <FeatureSection {...data.featureData} />
      <IndustriesSection {...data.industriesData} />
      <EventsSection {...data.eventsData} />
      <PrimaryCTA {...data.primaryCtaData} />
      <MetricsSection {...data.metricsData} />
      <Testimonials {...data.testimonialsData} />
      <ComparisonSection {...data.comparisonData} />
      <SecondaryCTA {...data.secondaryCtaData} />
    </>
  );
};

export default Content;
